import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaFilePdf } from 'react-icons/fa';
import { FiArrowRight } from 'react-icons/fi';
import './AboutSection.css';

// Sample wedding showcase images
const galleryImages = [
  {
    src: 'https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=800&auto=format&fit=crop',
    alt: 'Lakeside Mandap Setup',
  },
  {
    src: 'https://images.unsplash.com/photo-1544078751-58fee2d8a03b?q=80&w=800&auto=format&fit=crop',
    alt: 'Mountain Venue Setup',
  },
  {
    src: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?q=80&w=800&auto=format&fit=crop',
    alt: 'Royal Palace Night Illuminations',
  },
  {
    src: 'https://images.unsplash.com/photo-1583939003579-730e3918a45a?q=80&w=800&auto=format&fit=crop',
    alt: 'Oceanfront Beachside Ceremony',
  },
];

// Staggered Animation Variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1,
    },
  },
};

const imageVariants = [
  {
    hidden: { opacity: 0, x: -30, y: -30 },
    visible: { opacity: 1, x: 0, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  },
  {
    hidden: { opacity: 0, x: 30, y: -30 },
    visible: { opacity: 1, x: 0, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  },
  {
    hidden: { opacity: 0, x: -30, y: 30 },
    visible: { opacity: 1, x: 0, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  },
  {
    hidden: { opacity: 0, scale: 0.8, y: 40 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.9, ease: 'easeOut' } },
  },
];

export default function AboutSection() {
  return (
    <section className="about-section">
      
      {/* Background Glow */}
      <div className="about-bg-accent" />

      <div className="about-container">
        <div className="about-grid">
          
          {/* Left Side: Overlapping Image Collage */}
          <motion.div 
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="collage-container"
          >
            {/* Top Left Image */}
            <motion.div 
              variants={imageVariants[0]}
              whileHover={{ scale: 1.05, zIndex: 35 }}
              className="collage-item img-top-left"
            >
              <img src={galleryImages[0].src} alt={galleryImages[0].alt} className="collage-img" />
            </motion.div>

            {/* Top Right Image */}
            <motion.div 
              variants={imageVariants[1]}
              whileHover={{ scale: 1.05, zIndex: 35 }}
              className="collage-item img-top-right"
            >
              <img src={galleryImages[1].src} alt={galleryImages[1].alt} className="collage-img" />
            </motion.div>

            {/* Bottom Left Image */}
            <motion.div 
              variants={imageVariants[2]}
              whileHover={{ scale: 1.05, zIndex: 35 }}
              className="collage-item img-bottom-left"
            >
              <img src={galleryImages[2].src} alt={galleryImages[2].alt} className="collage-img" />
            </motion.div>

            {/* Bottom Right Image */}
            <motion.div 
              variants={imageVariants[3]}
              whileHover={{ scale: 1.05, zIndex: 35 }}
              className="collage-item img-bottom-right"
            >
              <img src={galleryImages[3].src} alt={galleryImages[3].alt} className="collage-img" />
            </motion.div>
          </motion.div>

          {/* Right Side: Text Content */}
          <motion.div 
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, ease: 'easeOut', delay: 0.2 }}
            className="about-content"
          >
            <p className="subtitle-tag">About Jayraj Group Destination Weddings</p>

            <h2 className="heading-playfair">
              Where Your Wedding Dreams Take Flight
            </h2>

            <p className="paragraph-text">
              At Destination Weddings India, we specialize in transforming your wedding dreams into reality by curating the perfect destination wedding experience. With years of expertise in planning and executing weddings in the most stunning locations across India.
            </p>

            <p className="paragraph-text">
              Our team of dedicated wedding consultants works closely with you to understand your vision, preferences, and desires. Whether it’s a serene beach ceremony, a romantic castle wedding, or an exotic cultural experience, we provide the finest wedding venues to match your vision.
            </p>

            <div className="know-more-wrapper">
              <a href="#" className="know-more-link">
                <span className="know-more-line" />
                <span>Know More</span>
                <FiArrowRight className="arrow-icon" />
              </a>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}